import { GetAllImpuestosDtoProps } from "api/DTOs/GetAllImpuestosDto"
import { TIPO_GRUPO_IMPUESTO } from "api/Types/TipoGrupoImpuesto"
import { TIPO_IMPUESTO_EMPRESA_ENUM } from "api/Types/TipoImpuestoEmpresaEnum"

export function impuestoOcrAdapter(impuesto?: GetAllImpuestosDtoProps) {
  const tipo: string =
    impuesto?.grupo?.tipo === TIPO_GRUPO_IMPUESTO.IMPUESTO_REPERCUTIDO
      ? "impuestos"
      : impuesto?.grupo?.tipo === TIPO_GRUPO_IMPUESTO.IMPUESTO_RETENIDO
      ? "retenciones"
      : "otros"
  // Actualmente se reciben valores negativos para colorear el listado de impuestos, aquí se extrae solo el valor absoluto
  const valorAbsoluto = impuesto?.valor && Math.abs(impuesto.valor)

  return {
    [tipo]: {
      label: impuesto?.nombre,
      value: {
        id: impuesto?.id,
        valor: valorAbsoluto,
        valorLabel: `${impuesto?.nombre} (${valorAbsoluto}%)`,
      },
      tipoGrupo: impuesto?.grupo?.tipo,
      tipo:
        impuesto?.tipo === TIPO_IMPUESTO_EMPRESA_ENUM.COMPRA
          ? "Compra"
          : impuesto?.tipo === TIPO_IMPUESTO_EMPRESA_ENUM.VENTA
          ? "Venta"
          : "Otro",
    },
  }
}
